import { useState } from 'react';
import { makeStyles } from '@mui/styles';


const useAddEditStaffAugmentationState = () => {
  const defaultStaffData = {
    requirement: '',
    location: '',
    description: '',
    date: null,
    mandatoryFields: [],
    optionalFields: '',
    status: '',
    noOfPositions: '',
    dealType: '',
    geography: '',
    isTeamVisible: false,
  };
  const defaultEmployeeData = {
    employeeName: {},
    employeeId: '',
    employeeEmail: '',
    status: null,
  };

  const useStyles = makeStyles({
    noOptions: {
      display: 'none',
    },
  });
  const styles = useStyles();

  const yesNoOptions = [
    { name: 'Yes' },
    { name: 'No' },
  ];

  const dealTypeOptions = [
    { name: 'Domestic' },
    { name: 'Global' },
  ];

  const lostOrDroppedTypeOptions = [
    { name: 'Lost' },
    { name: 'Dropped' },
  ];

  const [data, setData] = useState(defaultStaffData);
  const [skills, setSkills] = useState([]);
  const [errors, setErrors] = useState({});
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const [snackbar, setSnackbar] = useState({
    message: '',
    severity: '',
    open: false,
  });
  return {
    data,
    skills,
    errors,
    openSnackbar,
    snackbar,
    setData,
    setSkills,
    setErrors,
    setOpenSnackbar,
    setSnackbar,
    defaultEmployeeData,
    yesNoOptions,
    dealTypeOptions,
    lostOrDroppedTypeOptions,
    styles,
  };
};

export default useAddEditStaffAugmentationState;
